/**
 * PDP order card helpers: Continue label + live total after variant changes.
 */
(function () {
  function applyContinue(root) {
    (root || document).querySelectorAll('product-form[data-crisp-continue]').forEach((form) => {
      const span = form.querySelector('.product-form__submit > span');
      if (!span) return;
      const text = (span.textContent || '').trim();
      const addLabel = window.variantStrings && window.variantStrings.addToCart;
      if (addLabel && text === addLabel) span.textContent = 'Add to cart';
    });
  }

  function syncFooterTotal(html, sectionId) {
    if (!html || !sectionId) return;
    const source = html.getElementById('CrispTotal-' + sectionId);
    const dest = document.getElementById('CrispTotal-' + sectionId);
    if (source && dest) dest.innerHTML = source.innerHTML;
  }

  document.addEventListener('DOMContentLoaded', () => applyContinue());
  document.addEventListener('product-info:loaded', () => applyContinue());

  if (typeof subscribe === 'function') {
    subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
      const data = (event && event.data) || {};
      syncFooterTotal(data.html, data.sectionId);
      applyContinue();
    });
  }
})();
